import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/**
 * Custom Add Icon component using the provided SVG path
 * 
 * @param {Object} props - Component props from SvgIcon
 * @returns {JSX.Element} Custom add icon SVG component
 */
const CustomAddIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path 
        id="add-box" 
        d="M25.833,4.5H7.167A2.667,2.667,0,0,0,4.5,7.167V25.833A2.667,2.667,0,0,0,7.167,28.5H25.833A2.675,2.675,0,0,0,28.5,25.833V7.167A2.675,2.675,0,0,0,25.833,4.5ZM23.273,17.833c-.3.039-5.439,0-5.439,0s.005,4.956,0,5.333-.635.639-1.339.633-1.321-.411-1.328-.633,0-5.333,0-5.333-4.642.006-5.333,0-.825-.694-.825-1.361.255-1.3.825-1.306,5.333,0,5.333,0,.021-4.678,0-5.333,2.658-.956,2.667,0,0,5.333,0,5.333,5.028-.006,5.333,0,.694.628.694,1.294S23.568,17.794,23.273,17.833Z" 
        transform="translate(-4.5 -4.5)" 
        fill={props.fill || "white"}
      />
    </SvgIcon>
  );
};

export default CustomAddIcon;